import React from "react";

export default function TermsModal({ open, onConfirm, onCancel, busy }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h3 className="modal-title">Antes de continuar</h3>
        <p className="modal-body">
       El pago debe realizarse desde una tarjeta o cuenta bancaria a tu nombre. Pagos a través de terceros no serán aceptados.
        </p>
        <div className="modal-actions">
          <button className="btn btn-ghost" onClick={onCancel}>
            Cancelar
          </button>
          <button className="btn btn-primary" onClick={onConfirm} disabled={busy}>
            {busy ? "Procesando..." : "Entiendo, continuar"}
          </button>
        </div>
      </div>
    </div>
  );
}
